import { portalApi } from "./client";

// TPS Servicing Portal PR-G — portal-side client + DTO types for the firm's
// "Commissions" tab (earned servicing-fee income accumulating in the
// Commissions account). Mirrors the C# records the backend exposes under
// /api/portal/tps/commissions. No React Query in the portal — callers load with
// useState.

export interface TpsCommission {
  distributionId: string | null;
  loanId: string;
  loanNumber: string;
  /** DateOnly "YYYY-MM-DD". */
  periodStart: string;
  amount: number;
  status: string;
  stripeTransferId: string | null;
}

export interface TpsCommissionsSummary {
  totalEarned: number;
  count: number;
  items: TpsCommission[];
}

export const tpsCommissionsApi = {
  list: () => portalApi.get<TpsCommissionsSummary>("/tps/commissions"),
};
